import React from 'react';
import { useIntl } from 'react-intl';

import { Action, Label, useAnalyticAttrs } from 'services/analytics';
import FavoriteIcon from '../FavoriteIcon';
import messages from './messages';

import './toggleFavoriteButton.scss';

interface Props {
    isActive: boolean;
    toggle: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

const { Add, Remove } = Label;
const { ToggleFavorite } = Action;

const ToggleFavoriteButton: React.FC<Props> = ({ isActive, toggle }) => {
    const analytics = useAnalyticAttrs();
    const { formatMessage } = useIntl();

    const msg = isActive
        ? messages.removeFromFavorites
        : messages.addToFavorites;

    const title = formatMessage(msg);

    const onClick: DivEl['onClick'] = e => {
        e.preventDefault();

        toggle(e);
    };

    return (
        <div
            styleName="container"
            className="__app-ToggleFavoriteButton-container"
            {...analytics}
            data-action={ToggleFavorite}
            data-label={isActive ? Remove : Add}
            onClick={onClick}
            title={title}
        >
            <FavoriteIcon isActive={isActive} />
        </div>
    );
};

export default ToggleFavoriteButton;
